/**
 * 选项按钮（原站 I 组件 / E8jm2f + Pg6Oau + AyeIEn + tpJa93）。
 *
 * 原站用 lodash throttle(fn, 300, { trailing: false }) 包住点击：
 * 也就是 300ms 的前沿锁 —— 窗口内的重复点击被吞掉，同时加上按下放大的类。
 */
import { useCallback, useEffect, useRef, useState } from 'react';
import './answer.css';

/** 点击锁窗口（原站硬编码 300） */
const CLICK_LOCK = 300;

export interface AnswerButtonProps {
  text: string;
  onClick: () => void;
  disabled?: boolean;
}

export function AnswerButton({ text, onClick, disabled }: AnswerButtonProps) {
  const [pressed, setPressed] = useState(false);
  const lockedAt = useRef(0);

  useEffect(() => {
    setPressed(false);
    lockedAt.current = 0;
  }, [text]);

  const handleClick = useCallback(() => {
    if (disabled) return;
    const now = performance.now();
    // throttle（leading, trailing:false）：锁定期内直接丢弃
    if (now - lockedAt.current < CLICK_LOCK) return;
    lockedAt.current = now;
    setPressed(true);
    onClick();
  }, [disabled, onClick]);

  return (
    <div className={disabled ? 'answer isDisabled' : 'answer'}>
      <button type="button" className="answerLabel" disabled={disabled} onClick={handleClick}>
        <span className={pressed ? 'answerText isPressed' : 'answerText'}>{text}</span>
        <span className="answerText isGhost" aria-hidden="true">
          {text}
        </span>
      </button>
    </div>
  );
}
